/**
 * Created by brianschroer on 2/18/16.
 */

(function () {
    'use strict';

    Directives.OnboardingPaymentPlanFormDirective = function OnboardingPaymentPlanFormDirective() {
        // @ngInject
        function OnboardingPaymentPlanFormDirectiveControllerCtor($scope, $injector, $translate, UsersManager, OnboardingService, StripeHelperService) {
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'OnboardingPaymentPlanFormDirectiveController';

            this.UsersManager = UsersManager;
            this.OnboardingService = OnboardingService;
            this.StripeHelperService = StripeHelperService;

            this.buttonCopy = this.edit ? 'ONBOARDING.PAYMENT._SAVE_PAYMENT_' : 'ONBOARDING.PAYMENT._SUBMIT_PAYMENT_';
            this.titleCopy  = this.edit ? 'ONBOARDING.PAYMENT._EDIT_PAYMENT_INFO_' : 'ONBOARDING.PAYMENT._PAYMENT_INFO_';

            this.showDiscountInputField = false;

            this.alternativeFooter = this.altFooter || false;

            this.ApplyText = $translate.instant('SETTINGS.SUBSCRIPTION._APPLY_PROMO_CODE_');
            this.AppliedText = $translate.instant('SETTINGS.SUBSCRIPTION._APPLIED_PROMO_CODE_');
            this.btnApplyText = this.ApplyText;

            $scope.$watch('onboardingPaymentFormVm.isPromocodePricingPlans', function (newVal, oldVal) {
                if(oldVal !== newVal) {
                    this.btnApplyText = this.isPromocodePricingPlans ? this.AppliedText : this.ApplyText;
                }
            }.bind(this));
        }

        var OnboardingPaymentPlanFormDirectiveController = Class(Controllers.BaseController, {
            constructor: OnboardingPaymentPlanFormDirectiveControllerCtor,

            savePaymentPlan: function savePaymentPlan() {
                if (this.submittingPayment) {
                    return;
                }

                this.submittingPayment = true;

                 this.StripeHelperService.getStripeTokenNew(this.tokenProviderId).then(function (token) {
                    this.onSubmit({stripeToken: token, pricingPlanId: this.planId, role: this.cardRole});
                 }.bind(this))
                  .then(function () {
                    this.submittingPayment = false;
                  }.bind(this))
                  .catch(function () {
                    this.submittingPayment = false;
                  }.bind(this))
            },

            cancelSubmission: function cancelSubmission() {
                this.addCardForm.$setPristine();
                if (this.cancel) {
                    this.cancel();
                }
            },

            showDiscountInput: function showDiscountInput() {
                this.showDiscountInputField = true;
            },

            onPromoCodeTextChanged: function onPromoCodeTextChanged() {
                this.showLastError = false;
                this.isPromocodePricingPlans = false;
            },

            preventPropAndSubmitDiscount: function preventPropAndSubmitDiscount(e) {
                e.preventDefault();
                this.submitDiscountCode();
            },
        });


        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/onboarding/onboarding_payment_form/onboarding_payment_plan_form_template.html',
            controller: OnboardingPaymentPlanFormDirectiveController,
            controllerAs: 'onboardingPaymentFormVm',
            bindToController: true,
            scope: {
                planId: '@',
                planAmount: '@',
                isPromocodePricingPlans: '=?',
                onSubmit: '&',
                loading: '=?loading',
                edit: '=?edit',
                cardError: '=cardError',
                cancel: '&?',
                altFooter: '@?',
                cardRole: '@?',
                promoCode: '=?',
                submitDiscountCode: '&?',
                lastError: '=?',
                showLastError: '=?',
                hasPromoCode: '=?',
                isPayMode: '='
            }
        };
    };

}());
